import { useSearchParams } from "react-router-dom";
import { products, CATEGORIES } from "../data/products";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const [searchParams] = useSearchParams();
  const categoryFilter = searchParams.get("category");
  const searchQuery = searchParams.get("q");

  let filteredProducts = products;

  if (categoryFilter) {
    filteredProducts = filteredProducts.filter((p) => p.category === categoryFilter);
  }

  if (searchQuery) {
    const q = searchQuery.toLowerCase();
    filteredProducts = filteredProducts.filter(
      (p) =>
        p.name.toLowerCase().includes(q) ||
        p.description.toLowerCase().includes(q) ||
        p.category.toLowerCase().includes(q)
    );
  }

  return (
    <div className="container">
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ marginBottom: '8px' }}>
          {searchQuery ? `Search Results for "${searchQuery}"` : categoryFilter || "Our Products"}
        </h1>
        <p>Showing {filteredProducts.length} items</p>
      </div>

      <div className="grid">
        {filteredProducts.length === 0 ? (
          <div>
             <p>No products found! Try clearing filters or search for something else.</p>
          </div>
        ) : (
          filteredProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))
        )}
      </div>
    </div>
  );
}
